import { defineMessages } from 'react-intl';

export default defineMessages({
  error: {
    id: 'frontbucket.search.results.error',
    description: 'Text when the search returns an error',
    defaultMessage: `Oops! There's a problem`,
  },
  learnMoreLink: {
    id: 'frontbucket.search.results.learnMoreLink',
    description: 'Link text for learning more about code search',
    defaultMessage: `Learn more about code search`,
  },
  unknownErrorDescription: {
    id: 'frontbucket.search.results.unknownErrorDescription',
    description: 'Text when the search returns an unknown error',
    defaultMessage: 'Try again shortly',
  },
});
